import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
  GetAllUOm,
  GetAllCategory,
} from "adminApi/ItemsListApi/ItemsList";
import fields from "../json/ProductListFields.json";
import { validateForm } from "utils/validation";
import { ProductsListRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddProductForm from "./Componates/AddProductForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddProduct = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, ProductsListRules);

  const { data: CategoryOPction, loading: loadingCategory } = useFetchAllData(GetAllCategory);
  const { data: UOMOpction, loading: loadingUOM } = useFetchAllData(GetAllUOm);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, ProductsListRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Product Created successfully"


  );

  return (
    <>
      {(loadingSubmit || (loadingCategory || loadingUOM)) && <Spinner isSpinner={true} />}
      <AddProductForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Add Product"
        CategoryOPction={CategoryOPction}
        UOMOpction={UOMOpction}
      />
    </>
  );
};

export default AddProduct;
